import { Col, Spinner2, Text } from 'components';
import { Api, theme } from 'lib';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { SearchItem, SegmentControl } from './';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  z-index: 2;

  position: absolute;
  width: 406px;
  height: ${(props) => (props.tall ? 620 : 364)}px;
  left: 0px;
  top: 30px;
  overflow: hidden;
  ${(props) => props.tall && 'overflow-y: scroll;'}
  scrollbar-width: none;

  ::-webkit-scrollbar {
    display: none;
  }

  background-color: #fff;

  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.1);

  ${(props) =>
    props.isMobile &&
    `
    position: fixed;
    z-index: 3;
    width: 100vw;
    height: calc(100vh - 128px);
    left: 0;
    top: 128px;
  `}
`;

const BallBg = styled.img`
  width: ${(props) => (props.isMobile ? '100vw' : '440px')};
  position: absolute;
  bottom: 0;
`;

let timer;
const SearchOverlay = ({ value, visible, setVisible }) => {
  const [loading, setLoading] = useState(false),
    [type, setType] = useState('browse.top'),
    [searchData, setSearchData] = useState([]),
    user = useSelector((state) => state.user),
    { isMobile } = useSelector((state) => state.appState),
    { t } = useTranslation(),
    options = ['browse.top', 'browse.athletes', 'browse.teams', 'browse.tags', 'browse.fans'];

  useEffect(() => {
    switch (type) {
      case 'browse.top':
        handleSearch(value);
        break;

      case 'browse.athletes':
        handleSearch(value, 'athlete');
        break;

      case 'browse.fans':
        handleSearch(value, 'fan');
        break;

      case 'browse.teams':
        handleSearch(value, 'team');
        break;

      case 'browse.tags':
        handleSearch(value, 'tag');
        break;

      default:
    }
  }, [value, type]);

  async function handleSearch(val, type) {
    clearTimeout(timer);
    setLoading(true);

    timer = setTimeout(async () => {
      if (!val.trim().length) {
        setLoading(false);
        return setSearchData(null);
      }

      const res = await Api.post('/browse/search', { text: val, type });
      setLoading(false);
      if (!res) return;

      setSearchData(res);
    }, 300);
  }

  if (!value && !visible) return null;

  return (
    <Col pos="absolute" center>
      <Wrapper tall={!!value} isMobile={isMobile}>
        {!!value ? (
          loading && !searchData ? (
            <Col ht="100%" wid="100%" centerAll>
              <Spinner2 />
            </Col>
          ) : (
            <Col wid="100%" noFlex>
              <SegmentControl
                options={options}
                handleSelect={(x) => setType(options[x])}
                selectedIdx={options.findIndex((x) => x === type)}
              />

              <Col marg="24px 0 0">
                {searchData?.map((x, i) => (
                  <SearchItem item={x} key={i} fromSearch />
                ))}
              </Col>
            </Col>
          )
        ) : user.recentSearches?.length ? (
          <Col start wid="100%">
            <Text h4 marg="24px 24px">
              {t('browse.recent')}
            </Text>

            {user.recentSearches?.map((x, i) => (
              <SearchItem item={x} key={i} />
            ))}
          </Col>
        ) : (
          <Col centerAll start wid="100%">
            <Text wid="224px" center b1 col={theme.GREY_60} marg="48px 0 0">
              {t('browse.trySearchAthlete')}
            </Text>

            <BallBg
              isMobile={isMobile}
              src={require('assets/branding/partial-logo-upper-wide-grey-10.png')}
            />
          </Col>
        )}
      </Wrapper>
    </Col>
  );
};

export default SearchOverlay;
